module.exports = __webpack_public_path__ + "img/sick-icon.a534e444.png";